// Shared, module-level Google reviews fetcher + canonical CTA URLs.
// Both GoogleReviewsBanner (homepage) and GoogleTrustPill (/book, /contact)
// import from here so the browser issues only ONE /api/google-reviews call
// per session. The backend itself caches for 24 hours — this module cache
// simply prevents the frontend from re-hitting the internal endpoint on
// every route change / component mount.

let _cache = null;
let _inflight = null;

export function fetchGoogleReviews() {
  if (_cache) return Promise.resolve(_cache);
  if (_inflight) return _inflight;
  _inflight = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/google-reviews`)
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => { _cache = data; _inflight = null; return data; })
    .catch(() => { _inflight = null; return null; });
  return _inflight;
}

// Canonical CTA destinations — single source of truth for the whole site.
// READ  → Google's local reviews list for our Place ID.
// WRITE → Google's "Leave a review" dialog pre-bound to our Place ID.
// Never point either of these at a generic Google search URL.
export const GOOGLE_REVIEWS_READ_URL =
  "https://search.google.com/local/reviews?placeid=ChIJ986mxcvdekgRuvi94942kHY";
export const GOOGLE_REVIEWS_WRITE_URL =
  "https://search.google.com/local/writereview?placeid=ChIJ986mxcvdekgRuvi94942kHY";
